<header>
  <div class="logo-bar">
    <div class="container" style="margin-bottom:0px;">
      <div class="row-no-margin header-shadow" style="padding-top:20px;padding-bottom:20px;" >
        <div class="row-no-margin col-md-6">
          <div style="border-right: 1px solid #e2e1dd;">
            <a class="navbar-brand" [routerLink]="['/']">
              <img src="./assets/images/tolomatic-logo.png" />
            </a>

          </div>
          <div style="padding-left:20px;">
            <span style="line-height: 68px; vertical-align: middle; color: #333f48;font-size:25px;" [hidden]="HideNav">Tolomatic Portal</span>
          </div>
        </div>
       
        <div class="col-md-6 row-no-margin clear-padding" style="text-align:right;display:inline-block;font-size:11px;padding-top:2%;">
          <!--Login section-->
          <div *ngIf="CurUser != null " class="row-no-margin">
            <div class="col-md-12">

              <nav class="navbar  navbar-dark col-md-12 mx-right py-0" style="background:none;flex-direction:row;flex-wrap:nowrap;justify-content:right;">
                <div class="mx-right" style="display:flex;align-items:center;flex-wrap:nowrap;">
                  <span style="color: #a1a1a1;padding-right:5px; border-right:1px solid #a1a1a1;font-size:11px;">Welcome, <span style="color: #0072a7;">{{CurUser.FirstName}} ({{CurUser.Role}})</span></span>
                  <ul class="navbar-nav flex-grow mx-right">
                    <div class="nav-item dropdown" dropdown>
                      <span class="dropdown-toggle nav-link clickable" dropdownToggle style="color: #a1a1a1;padding-left:5px; font-size:11px;">My Settings <mat-icon style="vertical-align:middle;" class="small-icon clickable">settings</mat-icon></span>
                      <div style="position:absolute;" class="dropdown-menu" *dropdownMenu>
                        <a class="dropdown-item clickable" (click)="EditProfile()">Edit Profile</a>
                        <a class="dropdown-item clickable" (click)="Logout()">Log out</a>
                      </div>
                    </div>
                  </ul>
                </div>
              </nav>
            </div>

          </div>
          <div class="row-no-margin">
            <div class="col-md-12">
              <div class="mx-right" style="justify-content:right;display:flex;align-items:center;flex-wrap:nowrap;">
                <a style="color: #0072a7; padding-right: 20px; font-weight: 600; font-size: 11px; " class="inline-block" href="https://info.tolomatic.com/portal-feedback" target="_blank">
                  Leave Feedback
                </a>

              </div>
            </div>
          </div>
        </div>

        <!--<nav class="navbar navbar-expand-md navbar-dark col-md-5 mx-right py-0" style="background:none">
          <div class="container mx-right">
            <ul class="navbar-nav flex-grow mx-right">
              <div class="nav-item dropdown" dropdown>
                <a class="dropdown-toggle nav-link" dropdownToggle>
                  Users
                </a>
                <div class="dropdown-menu" *dropdownMenu>
                  <a [hidden]="IsGuestUser || !HasCurrentUser" class="dropdown-item" (click)="EditUserProfile()">My Profile</a>
                  <a [hidden]="!IsAdminUser" class="dropdown-item" [routerLink]="['/admin']">Admin Edit User</a>
                  <a [hidden]="HasCurrentUser && !IsGuestUser" class="dropdown-item" [routerLink]="['/createUser']">Create User</a>
                  <a [hidden]="!HasCurrentUser" class="dropdown-item" (click)="Logout_User()">Log Out</a>
                </div>
              </div>
              <div [hidden]="!HasCurrentUser" class="nav-item dropdown">
                <a class="nav-link" [routerLink]="['/projectLibrary']">
                  Projects
                </a>
              </div>
              <div class="nav-item inline-block">
                <a class="nav-link inline-block" href="https://info.tolomatic.com/sizeit-feedback" target="_blank">
                  Leave Feedback
                </a>
              </div>
            </ul>
          </div>
        </nav>-->
      </div>
      <div class="row-no-margin nav-container">
        
        <nav [hidden]="HideNav" class="navbar navbar-expand-md col-md-12 mx-right py-0" style="height:43px;">
          <div class="container mx-right">
            <ul style="list-style-type:none;" class="navbar-nav flex-grow mx-right" [hidden]="HideNav">
              <div class="nav-item dropdown">
                <a class="nav-link" [ngClass]="GetCSSClass('pricing')" [routerLink]="['/pricing']">Pricing</a>
              </div>
              <div class="nav-item dropdown">
                <a class="nav-link" [ngClass]="GetCSSClass('orderstatus')" [routerLink]="['/orderstatus']">Order Status</a>
              </div>
              <div class="nav-item dropdown">
                <a class="nav-link" [ngClass]="GetCSSClass('quotes')" [routerLink]="['/quotes']">Quotes</a>
              </div>
              <div class="nav-item dropdown">
                <a class="nav-link" [ngClass]="GetCSSClass('rma')" [routerLink]="['/rma']">RMAs</a>
              </div>
              <div class="nav-item dropdown">
                <a class="nav-link" [ngClass]="GetCSSClass('infocenter')" [routerLink]="['/infocenter']">Info Center</a>
              </div>
              <div class="nav-item dropdown">
                <a class="nav-link" [ngClass]="GetCSSClass('tolo-u')" [routerLink]="['/tolo-u']">Tolo-U 101</a>
              </div>
              <div class="nav-item dropdown">
                <a class="nav-link" [ngClass]="GetCSSClass('news')" [routerLink]="['/adminnews']">News</a>
              </div>
              <div class="nav-item dropdown" [hidden]="!IsAdminUser" dropdown>
                <a class="dropdown-toggle nav-link" dropdownToggle>
                  Admin
                </a>
                <div class="dropdown-menu" *dropdownMenu>
                  <!--<a class="dropdown-item" [hidden]="!IsTolomaticUser" [routerLink]="['/admininfocenter']">Info Center</a>-->
                  <!--<a class="dropdown-item" [hidden]="!IsTolomaticUser" [routerLink]="['/adminnews']">News/Updates</a>-->
                  <a class="dropdown-item" [routerLink]="['/admin/manageusers']">Users</a>
                  <a class="dropdown-item" [routerLink]="['/admin/leadtimerules']">Lead Time Rules</a>
                </div>
              </div>

            </ul>
          </div>
         
        </nav>
        
      </div>
    </div>

  </div>
</header>
